export default __webpack_public_path__ + "static/media/redtiger.eed098e2.jpg";